import React, { useEffect } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Progress,
  Typography
} from 'web-library';
import { useTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { useDispatch } from 'react-redux';
import { FileUploadState } from '../../models/File';
import { disableIdleTimeout, enableIdleTimeout } from '../../store/appSlice';

const useStyles = makeStyles()((theme) =>
({
  dialogContainer: {
    display: 'flex',
    margin: theme.spacing(2),
    alignItems: 'center',
    justifyContent: 'center',
  },
  dialogContent: {
    padding: theme.spacing(1),
  },
  dialogGrid:{
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center'
  },
}));

export interface DownloadProgressModalProps {
  /** to define downloading status
   * * */
  fileDownloadStatus: FileUploadState;

  /** to define modal open/close state
   * */
  modalState: boolean;

  /** to handle dialog close
   * */
  onDialogClose?: () => void;
}

const DownloadProgressModal: React.FC<DownloadProgressModalProps> = (
  props: DownloadProgressModalProps
) => {
  const {
    modalState = false,
    fileDownloadStatus = 'UPLOADING',
    onDialogClose = () => null,
  } = props;
  const { classes } = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();

  // Disable the idle timer countdown when downloading document.
  useEffect(() => {
    if (modalState) {
      dispatch(disableIdleTimeout());
    } else {
      dispatch(enableIdleTimeout());
    }
  }, [dispatch, modalState]);

  return (
    (<Dialog
      id="opadmin-download-dialog"
      className={classes.dialogContainer}
      fullWidth
      open={modalState}
      maxWidth="sm"
    >
      <DialogContent className={classes.dialogContent}>
        <Grid wrap="wrap" container direction="column" spacing={2} className={classes.dialogGrid}>
          <Grid xs={12}>
            {(fileDownloadStatus === 'UPLOADING' ||
              fileDownloadStatus === 'IDLE' ||
              fileDownloadStatus === 'GENERATING') && (
                <Typography display="inline" variant="h4">
                  Processing
                </Typography>
              )}
            {(fileDownloadStatus === 'TIMEOUT' || fileDownloadStatus === 'FAILED') && (
              <Typography display="inline" variant="h4">
                Failed to download, please try again later.{' '}
              </Typography>
            )}
          </Grid>
          {(fileDownloadStatus === 'UPLOADING' ||
            fileDownloadStatus === 'IDLE' ||
            fileDownloadStatus === 'GENERATING') && (
              <Grid xs={12}>
                <Progress color="secondary" />
              </Grid>
            )}
        </Grid>
      </DialogContent>
      {(fileDownloadStatus === 'TIMEOUT' ||
        fileDownloadStatus === 'FAILED' ||
        fileDownloadStatus === 'GENERATING') && (
          <DialogActions id="oppadmin-dialog-action">
            <Grid container justify="center" wrap="nowrap" direction="row">
              <Button variant="contained" onClick={onDialogClose}>
                Ok
              </Button>
            </Grid>
          </DialogActions>
        )}
    </Dialog>)
  );
};
export default DownloadProgressModal;
